export const CONTENT_FIELDS = ["title", "description", "development_potential", "exit_strategy", "investment_strengths", "investment_risks"];

export const contentLanguage = (i18n) => (i18n.resolvedLanguage || i18n.language || "en").split("-")[0];

// Selected language first (including a translations.en entry when the source was authored in another
// language), then the original/source field as fallback.
export function localizedField(p, field, i18n) {
  const lang = typeof i18n === "string" ? i18n : contentLanguage(i18n);
  return p?.translations?.[lang]?.[field] || p?.[field];
}

export function localizedProperty(p, i18n) {
  const out = { ...p };
  CONTENT_FIELDS.forEach((f) => { out[f] = localizedField(p, f, i18n); });
  return out;
}
